<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName.replace("~","") }}</p>
      <small> {{ GetCurrentWork() }} </small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="photoURL" key="onlineImg" :src="photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 11rem">

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li> -->

          <!-- <li v-if="!isClient" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/tasks')">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li v-if="!isClient" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/timeEntries')">
            <feather-icon icon="ClockIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Time Entries</span>
          </li>
          
          <li v-if="!isClient" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/dailyTime')">
            <feather-icon icon="CalendarIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Daily Time</span>
          </li>

          <li v-if="isClient" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/dashboard')">
            <feather-icon icon="LayoutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Dashboard</span>
          </li>

          <li v-if="isClient" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/projects')">
            <feather-icon icon="FolderIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Projects</span>
          </li>

          <li v-if="isClient" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/invoicing')">
            <feather-icon icon="CreditCardIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Invoicing</span>
          </li>
 -->

          <li v-if="isAdmin" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/settings')">
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Settings</span>
          </li>
          

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li> -->

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li> -->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-dropdown vs-trigger-click class="ml-5 my-2 cursor-pointer">

                <feather-icon icon="UsersIcon" svgClasses="h-5" class="cursor-pointer" @click.prevent></feather-icon>

                <vs-dropdown-menu style="z-index: 200001; min-width: max-content;">
                  <!-- <vs-dropdown-item @click="ClickSimulation(42)">ALL</vs-dropdown-item> -->
                        <vs-dropdown-item v-for="(label, index) in workerList" :key="index" @click="ClickSimulation(label.WorkerID)">{{ (label.WorkerName || '').replace("~","") }}</vs-dropdown-item> 
                       

                </vs-dropdown-menu>
    </vs-dropdown>

  </div>
</template>

<script>
import Vue from 'vue'

export default {
  computed: {
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    currentTimeEntry () {
      return this.$store.getters.GetCurrentTimeEntry
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    photoURL () {
      return this.$store.state.photoURL
    },
    lastTimeEntry () {
      return this.$store.getters.GetTimeEntryList.filter(x => x.WorkerID == this.workerID)[0]
    },
    clientList () {
      return this.$store.getters.GetClientList
    },
    isClient () {
      return this.$store.getters.GetIsClient
    },
    workerID () {
      return this.$store.getters.GetWorkerID
    },
    workerList () {
      return this.$store.getters.GetWorkerList
    }
    
  },
  methods: {
    ClickSimulation (simulationID) {
      this.$store.dispatch('ActionSetSimulation', {simulation: simulationID})
    },
    GetCurrentWork () {

      if (this.lastTimeEntry == null) return ''

      if (this.currentTimeEntry != null) {
        if (this.currentTimeEntry.ClientID != null) {
          return `Working for ${  this.ClientNameByID(this.currentTimeEntry.ClientID)}`
        }
      }


      return `Last Worked for ${  this.ClientNameByID(this.lastTimeEntry.ClientID)}`
    },
    ClientNameByID (id) {


      const def = 'Client'
      if (this.clientList == null) return def
      const c = this.clientList.find(x => x.ClientID == id)
      if (c == null) return def
      return c.ClientName
      
    },
    logout () {
      //localStorage.removeItem('userInfo')
      // window.location.href = `${ process.env.VUE_APP_ID_UI }?action=logout&from=timetracker`
      this.$auth.logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      })
      // this.$store.dispatch("ActionLogout").then((response) => {
      //   this.$router.push('/pages/login')

      // })
      // This is just for demo Purpose. If user clicks on logout -> redirect
    }
  }
}
</script>
